import { Tooltip } from "antd";
import React from "react";

function getAuth(typeCode: string) {
  const permissionList = sessionStorage.getItem("permissions");
  if (typeCode && permissionList && permissionList?.length) {
    return permissionList.indexOf(typeCode) > -1;
  }
  return false;
}
export const wrapAuth = (ComposedComponent: any, typeCode: string) => {
  if (ComposedComponent) {
    if (getAuth(typeCode)) {
      return ComposedComponent;
    }
    return (
      <>
        {" "}
        <Tooltip title="暂无权限">
          {React.cloneElement(ComposedComponent, {
            disabled: true,
            className: `${ComposedComponent?.props?.className} driver-disabled`,
            onClick: (e) => {
              e.stopPropagation();
            },
          })}
        </Tooltip>
      </>
    );
  }
  return false;
};

/**
 * 权限包装函数 - 禁用模式（带 Tooltip）
 * 没有权限时直接禁用按钮，并显示"暂无权限"提示
 */
export const wrapAuthDisable = (ComposedComponent: any, typeCode: string) => {
  if (ComposedComponent) {
    if (getAuth(typeCode)) {
      return ComposedComponent;
    }
    return (
        <Tooltip title="暂无权限">
          {React.cloneElement(ComposedComponent, {
            disabled: true,
            className: `${ComposedComponent?.props?.className} driver-disabled`,
            onClick: (e: any) => {
              e.preventDefault();
              e.stopPropagation();
            },
          })}
        </Tooltip>
    );
  }
  return false;
};

export const disabledAuth = (typeCode:string)=>{
  const permissionList = sessionStorage.getItem("permissions");
  return  !permissionList?.includes(typeCode);
}
